import { PaymentMethods, LocalStorageEnum, otherPromotionTypesEnum, shoppingMethod, newNexusRegistrationCodeEnum, orderPrefixes, productListingTypeEnum, JKOAMerchantTypes, errorTypesEnum, DonationData, hybridAppSourceChannelEnum } from '../utility/enums';
import { CART_ITEM_FUNCTIONS_URL, CART_ITEM_HANDLE_URI, CyberSource_URL, CyberSource_Token_Create_URL } from '../utility/environment_config';
import { post, get } from "../utility/apiClient";
import { getPersonalizationDataCollection } from '../utility/v2.0/commonFunctionsV2';

/*-- Imports for redux --*/
import { store } from '../redux/store';
import { showMessageBox } from '../redux/actions/messageBoxActions';
import { updateIsNexusFlag, updateIsTemporaryCart } from '../redux/actions/userDetailsActions';
import { showLoadingScreen, hideLoadingScreen } from '../redux/actions/loadingScreenActions';
import { resetNexusRegistrationDetail } from '../redux/actions/nexusRegistrationDetailActions';
import { addItemToCart, updateItemCart, removeItemFromCart, resetItemCart } from '../redux/actions/itemCartActions';
import { setOrderPromotionDetails } from '../redux/actions/orderPromotionActions';
import { setOrderFreeIssuePromotionDetails } from '../redux/actions/orderFreeIssuePromotionActions';
import { addWebDataCollection} from '../redux/actions/webDataCollectionActions';
import { addPromotionItems, resetPromotionItems } from '../redux/actions/promotionItemsActions';
import { updateUserRedirect } from '../redux/actions/userRedirectActions';
import { resetNexusRedemption, updateFullNexusCheckout, updateNexusRedeemedAmountCartValueComparisonAcknowledge } from '../redux/actions/nexusRedemptionAction';
import { addCalculatedPromotionResult, resetCalculatedPromotionResult } from '../redux/actions/calculatedPromotionResultActions';
import { jkoaPurchaseYes, jkoaPurchaseNo } from '../redux/actions/jkoaPurchaseAction';
import { AddItemToCartEvent, RemoveItemFromCartEvent, AddItemToCartEventGA4, RemoveItemFromCartEventGA4 } from '../utility/googleAnalytics';
import { resetPreferenceModal } from '../redux/actions/preferenceModalActions';
import { algonomyAddToCartPageRequest } from './algonomy';
import { resetLoyaltyRegistrationDetail } from '../redux/actions/V2_0/loyaltyRegistrationDetailActions';
import { isReactNativeWebView } from '../hybridApp/helpers';
import { decrypt } from './v2.0/encryptionServiceV2';
import {addSuggestedItems} from "../redux/actions/suggestedItemsActions";

/*-- General Common functions --*/
export function toCurrency(number) {
    return Number(parseFloat(number).toFixed(2)).toLocaleString('en', {
        minimumFractionDigits: 2
    });
};

export function toCurrencyDecimal(number) {
    return Number(parseFloat(number).toFixed(2));
};

export function ItemGrossAmount() {
    const state = store.getState();
    return "Rs. " + toCurrency(state.itemCart.map(v => v.itemTotal).reduce((sum, current) => sum + current, 0))
};

export function PolytheneBagCharge(isString = true) {
    const state = store.getState();
    if (state.webDataCollection.systemConfiguration.isPolytheneBagChargesApplied) {
        //Items that want to exclude add here
        if (state.jkoaPurchase) {
            return isString ? "Rs. 0.00" : 0;
        }

        let grossWithgv = state.itemCart.map(v => v.itemTotal).reduce((sum, current) => sum + current, 0)

        //Removing GiftVouchers and Nexus Card from the gross
        let gv = state.itemCart.filter(a => (a.subDepartmentCode == "UGV" || a.itemCode == newNexusRegistrationCodeEnum.newNexusRegistrationCode))
        let gvAmount = 0;
        if (gv) {
            gvAmount = gv.map(v => v.itemTotal).reduce((sum, current) => sum + current, 0)
        }
        let gross = grossWithgv - gvAmount;
        if (gross == 0) {
            return isString ? "Rs. 0.00" : 0;
        }
        
        let slelectedSet = state.webDataCollection.polytheneChargesList.find(a => (
                                (Number(a.minimumValue) <= Number(gross)) && 
                                (Number(gross) <= Number(a.maximumValue))
                        ))
        let val = slelectedSet?.amount ?? 0.00
        return isString ? "Rs. " + toCurrency(val) : val;
    } else {
        return isString ? "Rs. 0.00" : 0;
    }
    
    
}

export function ItemDiscountedAmount() {
    const state = store.getState();
    return "Rs. " + toCurrency(state.itemCart.map(v => v.discountedTotal).reduce((sum, current) => sum + current, 0))
};

export function ItemTotalDiscount(promoCodeDiscountedAmount = 0) {
    ItemTotalNexusDiscount();
    ItemTotalKeellsDiscount();
    let otherDiscount = TotalOtherDiscount(promoCodeDiscountedAmount);
    const state = store.getState();
    return "Rs. " + toCurrency((state.itemCart.map(v => v.discountValue).reduce((sum, current) => sum + current, 0)) + otherDiscount)
};

export function ItemCount() {
    const state = store.getState();
    return state.itemCart.length;
};

export function FreeIssueItemCount() {
    const state = store.getState();
    if (state.itemCart.length > 0) { return state.orderFreeIssuePromotionDetails.length; }
    else { return 0 }
};

export function ItemDeliveryCharge(deliveryType, isNexusCardOnly = false) {
    if (deliveryType === shoppingMethod.delivery && !isNexusCardOnly) {
        const state = store.getState();
        return "Rs. " + toCurrency(state.webDataCollection.systemConfiguration.orderDeliveryCharge)
    } else {
        return "Rs. 0.00"
    }
};

export function ExpressDeliveryCharge() {
    const state = store.getState();
    return "Rs. " + toCurrency(state.webDataCollection.systemConfiguration.expressDeliveryCharge)
}

export function ItemFinalTotal(deliveryType, isNexusCardOnly = false, isExpress = false, promoCodeDiscountedAmount = 0, toCalaculatePromoCodeDiscountedAmount = false) {
    let otherDiscount = TotalOtherDiscount(promoCodeDiscountedAmount);
    let value = 0;
    const state = store.getState();
    let itemCart = [];

    //Due to PromoCode
    if (toCalaculatePromoCodeDiscountedAmount) {
        itemCart = state.itemCart.filter(elm => (
            elm.departmentCode !== "L" //Liquor
            && elm.subDepartmentCode !== "UGV" //Gift Vouchers
            && elm.categoryCode !== "U7294" //Nexus
        ));
    } else {
        itemCart = state.itemCart;
    }

    if (deliveryType === shoppingMethod.delivery && !isNexusCardOnly) {
        if (itemCart.map(v => v.discountedTotal).reduce((sum, current) => sum + current, 0) == 0) { return "Rs. 0.00" }
        else {
            let expressDeliveryCost = isExpress ? state.webDataCollection.systemConfiguration.expressDeliveryCharge : 0.00;
            value = (itemCart.map(v => v.discountedTotal).reduce((sum, current) => sum + current, 0)) +
                (state.webDataCollection.systemConfiguration.orderDeliveryCharge + expressDeliveryCost) -
                (otherDiscount + (state.nexusRedemption.isRedeemed ? state.nexusRedemption.redeemedAmount : 0));
        }

    } else {
        value = (itemCart.map(v => v.discountedTotal).reduce((sum, current) => sum + current, 0)) - (otherDiscount + (state.nexusRedemption.isRedeemed ? state.nexusRedemption.redeemedAmount : 0));
    }
    if (value > 0) {
        return "Rs. " + toCurrency(value + PolytheneBagCharge(false))
    }
    else {
        return "Rs. 0.00"
    }
}

export function NexusAutoFillFinalTotal(deliveryType, nexus, promoCodeDiscountedAmount = 0) {
    const state = store.getState();
    let otherDiscount = TotalOtherDiscount(promoCodeDiscountedAmount);
    let value = 0;
    let totalNexus = 0;
    let isExpDelevery = state.orderData.IsExpressDelivery;
    totalNexus = parseFloat(nexus);
    if (deliveryType === shoppingMethod.delivery) {
        if (state.itemCart.map(v => v.discountedTotal).reduce((sum, current) => sum + current, 0) == 0) { return "Rs. 0.00" }
        else {
            value = (state.itemCart.map(v => v.discountedTotal).reduce((sum, current) => sum + current, 0)) + state.webDataCollection.systemConfiguration.orderDeliveryCharge - (otherDiscount + (state.nexusRedemption.isRedeemed ? state.nexusRedemption.redeemedAmount : 0)) + (PolytheneBagCharge(false));
        }
    } else {
        value = (state.itemCart.map(v => v.discountedTotal).reduce((sum, current) => sum + current, 0)) - (otherDiscount + (state.nexusRedemption.isRedeemed ? state.nexusRedemption.redeemedAmount : 0)) + (PolytheneBagCharge(false))
    }

    if (isExpDelevery === true) {
        let expressDeliveryAmount = state.webDataCollection.systemConfiguration.expressDeliveryCharge;
        value = (value + expressDeliveryAmount);
    }

    if (value > totalNexus) {
        return totalNexus
    }
    else {
        return value
    }
};

export function ExpectedItemFinalTotalAfterReemed(deliveryType, isNexusCardOnly, isExpress = false, promoCodeDiscountedAmount = 0) {
    let otherDiscount = TotalOtherDiscount(promoCodeDiscountedAmount);
    let value = 0;
    if (deliveryType === shoppingMethod.delivery && !isNexusCardOnly) {
        const state = store.getState();
        if (state.itemCart.map(v => v.discountedTotal).reduce((sum, current) => sum + current, 0) == 0) { return "Rs. 0.00" }
        else {
            let expressDeliveryCost = isExpress ? state.webDataCollection.systemConfiguration.expressDeliveryCharge : 0.00;
            value = (state.itemCart.map(v => v.discountedTotal).reduce((sum, current) => sum + current, 0)) +
                (state.webDataCollection.systemConfiguration.orderDeliveryCharge + expressDeliveryCost) - (otherDiscount + state.nexusRedemption.redeemedAmount);
        }
    } else {
        const state = store.getState();
        value = (state.itemCart.map(v => v.discountedTotal).reduce((sum, current) => sum + current, 0)) - (otherDiscount + state.nexusRedemption.redeemedAmount)
    }

    if (value > 0) {
        return "Rs. " + toCurrency(value + PolytheneBagCharge(false))
    }
    else {
        return "Rs. 0.00"
    }
};

export function ItemFinalTotalDecimal(deliveryType, isNexusCardOnly = false, isExpress = false, promoCodeDiscountedAmount = 0) {
    let otherDiscount = TotalOtherDiscount(promoCodeDiscountedAmount);
    if (deliveryType === shoppingMethod.delivery && !isNexusCardOnly) {
        const state = store.getState();
        if (state.itemCart.map(v => v.discountedTotal).reduce((sum, current) => sum + current, 0) == 0) { return "Rs. 0.00" }
        else {
            let expressDeliveryCost = isExpress ? state.webDataCollection.systemConfiguration.expressDeliveryCharge : 0.00;
            return (state.itemCart.map(v => v.discountedTotal).reduce((sum, current) => sum + current, 0)) +
                (state.webDataCollection.systemConfiguration.orderDeliveryCharge + expressDeliveryCost) -
                (parseFloat(otherDiscount) +
                    parseFloat(state.nexusRedemption.isRedeemed ? state.nexusRedemption.redeemedAmount : 0)) + parseFloat(PolytheneBagCharge(false))
        }
    } else {
        const state = store.getState();
        return (state.itemCart.map(v => v.discountedTotal).reduce((sum, current) => sum + current, 0)) - (parseFloat(otherDiscount) + parseFloat((state.nexusRedemption.isRedeemed ? state.nexusRedemption.redeemedAmount : 0))) + parseFloat(PolytheneBagCharge(false))
    }
};

export function ExpectedItemFinalTotalDecimalAfterReemed(deliveryType, isNexusCardOnly, isExpress = false, promoCodeDiscountedAmount = 0) {
    let otherDiscount = TotalOtherDiscount(promoCodeDiscountedAmount);
    if (deliveryType === shoppingMethod.delivery && !isNexusCardOnly) {
        const state = store.getState();
        if (state.itemCart.map(v => v.discountedTotal).reduce((sum, current) => sum + current, 0) == 0) { return "Rs. 0.00" }
        else {
            let expressDeliveryCost = isExpress ? state.webDataCollection.systemConfiguration.expressDeliveryCharge : 0.00;
            return (state.itemCart.map(v => v.discountedTotal).reduce((sum, current) => sum + current, 0)) +
                (state.webDataCollection.systemConfiguration.orderDeliveryCharge + expressDeliveryCost) - (otherDiscount + state.nexusRedemption.redeemedAmount) + parseFloat(PolytheneBagCharge(false))
        }
    } else {
        const state = store.getState();
        return (state.itemCart.map(v => v.discountedTotal).reduce((sum, current) => sum + current, 0)) - (otherDiscount + state.nexusRedemption.redeemedAmount) + parseFloat(PolytheneBagCharge(false))
    }
};

export function ItemTotalNexusDiscount() {
    const state = store.getState();
    let value = 0;
    state.itemCart.map(item => {
        item.promoDetails.map(promo => {
            if (promo.otherPromotionTypeID == otherPromotionTypesEnum.NexusDeals) {
                value += item.discountValue;
                return;
            }
        });
    });
    return "Rs. " + toCurrency(value);
};

export function ItemTotalKeellsDiscount() {
    const state = store.getState();
    let value = 0;
    state.itemCart.map(item => {
        item.promoDetails.map(promo => {
            if (promo.otherPromotionTypeID == otherPromotionTypesEnum.KeellsDeals) {
                value += item.discountValue;
                return;
            }
        });
    });
    return "Rs. " + toCurrency(value);
};

export function ItemTotalBuyMoreSaveMoreDiscount() {
    const state = store.getState();
    let value = 0;
    state.itemCart.map(item => {
        item.promoDetails.map(promo => {
            if (promo.otherPromotionTypeID == otherPromotionTypesEnum.BuyMoreSaveMore) {
                value += item.discountValue;
                return;
            }
        });
    });
    return "Rs. " + toCurrency(value);
};

export function TotalOtherDiscount(promoCodeDiscountedAmount = 0) {
    const state = store.getState();

    let promoDiscountedAmount = 0

    if (isNaN(promoCodeDiscountedAmount)) { promoDiscountedAmount = 0 }
    else { promoDiscountedAmount = Number(promoCodeDiscountedAmount) };


    if (state.itemCart.length > 0) {
        return (state.orderPromotionDetails.map(v => v.discountAmount).reduce((sum, current) => sum + current, 0)) + promoDiscountedAmount;
    }
    else { return 0 + promoDiscountedAmount }
};

export function NexusRedeemedPoints(isRedeemed) {
    if (isRedeemed) {
        const state = store.getState();
        return "Rs. " + toCurrency(state.nexusRedemption.isRedeemed ? state.nexusRedemption.redeemedAmount : 0)
    } else {
        return "Rs. 0.00"
    }
};

export function ExpectedNexusRedeemedPoints(isRedeemed) {
    if (isRedeemed) {
        const state = store.getState();
        return "Rs. " + toCurrency(state.nexusRedemption.redeemedAmount)
    } else {
        return "Rs. 0.00"
    }
};

/*-- End of general Common functions --*/

/**
 * Date     :   2020-07-02
 * Remark   :   Add new product to the cart
 * @param {*} product 
 */
export function AddNewItem(product, pageId) {
    const state = store.getState();
    let tempMinQty = product.minQty > 0 ? product.minQty : 1;

    let currentQty = product.slabQty > 0 ? product.slabQty : 1;
    let maxQty = product.maxQty > 0 ? product.maxQty : 999;
    let stockQty = product.stockInHand;

    if (CheckQuantity(currentQty, maxQty, stockQty)) {
        let list = {
            itemID: product.itemID,
            quantity: product.minQty > 0 ? product.minQty : 1,
            itemName: product.name,
            amount: product.amount,
            itemTotal: (tempMinQty / 1) * product.amount,
            itemImage: product.imageUrl,
            minQty: product.minQty > 0 ? product.minQty : 1,
            maxQty: product.maxQty > 0 ? product.maxQty : 999,
            slabQty: product.slabQty > 0 ? product.slabQty : 1,
            discountValue: 0,
            promoDetails: [],
            discountedTotal: (tempMinQty / 1) * product.amount,
            uom: product.uom === "KG" ? product.uom : "Unit",
            isAvailable: product.isAvailable,
            stockInHand: product.stockInHand,
            isSellingToday: product.isSellingToday,
            departmentCode: product.departmentCode,
            subDepartmentCode: product.subDepartmentCode,
            categoryCode: product.categoryCode,
            merchantID: product.merchantID,
            itemCode: product.itemCode
        }

        CalculatePromotion(list, state.promotionItems, state.userDetails, (result) => {
            if (result) {
                store.dispatch(addItemToCart(result)).then(() => {
                    CheckIfFullNexusCheckout();
                });
            }
            else {
                store.dispatch(addItemToCart(list)).then(() => {
                    CheckIfFullNexusCheckout();
                });
            }
        });

        UpdateCosmosDB();
        AddItemToCartEvent(list);
        AddItemToCartEventGA4(list, state.shoppingPreference.outletCode)
       //algonomyAddToCartPageRequest(product.itemCode, state.shoppingPreference.outletCode);

        // if (product.clickTrackingURL){
        //     let algonomyClickTrackingRequesturl = {
        //         Url:product.clickTrackingURL
        //     };
        //     post("/Algonomy/ClickTracking", algonomyClickTrackingRequesturl)
        // }

        //Show nexus deals only for nexus members message
        // -- Commented by Rukshan 2020-07-04 according to the request by JMSL team.
        // let promos = state.promotionItems.filter(x => x.itemID === product.itemID);
        // if (promos.length > 0) {
        //     if (promos[0].promoCategoryID === promotionTypesEnum.NexusDeals && !state.userDetails.isNexus) {
        //         let popupBox = {
        //             show: true,
        //             imageURL: "https://essstr.blob.core.windows.net/uiimg/PopupBox/NexusRegPopup.png",
        //             themeColor: "#233f87",
        //             buttonText1: "Sign up with us",
        //             buttonText2: "Go to my account",
        //             isConfirmation: true,
        //             callBackFunction: (response) => {
        //                 if (response) {
        //                     this.props.resetPopupBox().then(() => { window.location.href = "/nexusregistration" })
        //                 } else {
        //                     this.props.resetPopupBox().then(() => { window.location.href = "/myAccount" })
        //                 }
        //             }
        //         }
        //         store.dispatch(showPopupBox(popupBox));
        //     }
        // }
    }
};

/**
 * Date     :   2020-07-08
 * Remark   :   Check max Quantity with Stock 
 * @param {*} product 
 */
export function CheckQuantity(currentQty, maxQty, stockQty) {
    let isValid = true;

    if (currentQty > maxQty || currentQty > stockQty) {
        isValid = false;
        let messageBox = {
            show: true,
            title: "Oops!",
            className: "warning",
            content: currentQty > maxQty ? "Sorry, you have reached the maximum quantity limit you can purchase of this product" : "Sorry, due to limited stock availability, this is the maximum quantity you can purchase at the moment",
            isConfirmation: false,
            callBackFunction: null
        }
        store.dispatch(showMessageBox(messageBox));
    }

    return isValid;
}

/**
 * Date     :   2020-07-02
 * Remark   :   Function to increment product quantity from 
 * @param {*} product 
 */
export function IncrementItem(product, cartOrCheckout,pageId) {
    const state = store.getState();

    decrypt(state.userDetails.customerID).then((decryptedID)=>{
            if (state.userDetails.isGuest) {
        CheckGuestLogin((isGuest) => { });
    }
    else if (decryptedID <= 0) {
        UserLoginPrompt();
    }
    else {
        if (!(newNexusRegistrationCodeEnum.newNexusRegistrationCode === product.itemID)) {
            if (state.itemCart.length > 0) {
                let record = state.itemCart.find(x => x.itemID === product.itemID);
                if (record) {
                    let newQuantity = (record.quantity * 10 + record.slabQty * 10) / 10;

                    if (CheckQuantity(newQuantity, record.maxQty, record.stockInHand)) {
                        let newRecord = {
                            itemID: product.itemID,
                            quantity: (record.quantity * 10 + record.slabQty * 10) / 10,
                            itemName: record.itemName,
                            amount: record.amount,
                            itemTotal: ((record.slabQty / 1) * record.amount) + record.itemTotal,
                            itemImage: record.itemImage,
                            minQty: record.minQty,
                            maxQty: record.maxQty,
                            slabQty: record.slabQty,
                            discountValue: record.discountValue,
                            promoDetails: record.promoDetails,
                            discountedTotal: record.discountedTotal,
                            uom: record.uom,
                            isAvailable: record.isAvailable,
                            stockInHand: record.stockInHand,
                            isSellingToday: record.isSellingToday,
                            departmentCode: product.departmentCode,
                            subDepartmentCode: product.subDepartmentCode,
                            categoryCode: product.categoryCode,
                            merchantID: product.merchantID,
                            itemCode: product.itemCode
                        }
                        var updatedResult = state.itemCart;

                        CalculatePromotion(newRecord, state.promotionItems, state.userDetails, (result) => {
                            if (result) {
                                updatedResult[state.itemCart.indexOf(record)] = result;
                            }
                            else {
                                updatedResult[state.itemCart.indexOf(record)] = newRecord;
                            }
                            store.dispatch(resetItemCart());
                            store.dispatch(updateItemCart(updatedResult)).then(() => {
                                CheckIfFullNexusCheckout();
                            });;

                            const state2 = store.getState();
                            //UpdateCosmosDB();
                        });
                        AddItemToCartEvent(newRecord)
                        AddItemToCartEventGA4(newRecord, state.shoppingPreference.outletCode)
                    }
                } else { AddNewItem(product,pageId) }
                if (cartOrCheckout == true) {
                    CalculateOrderDiscount();
                }
            } else { AddNewItem(product,pageId) }
        }
    }
    })

};

/**
 * Date     :   2020-07-02
 * Remark   :   Function to decrement product quantity from the cart
 * @param {*} product 
 */
export function DecrementItem(product, cartOrCheckout) {
    if (!(newNexusRegistrationCodeEnum.newNexusRegistrationCode === product.itemID)) {
        const state = store.getState();
        if (state.nexusRedemption.isRedeemed) {
            //NexusReverseForCart(DecrementItemCore.bind(null, product, cartOrCheckout));
            CheckNexusReversal(DecrementItemCore.bind(null, product, cartOrCheckout), product);
        } else {
            DecrementItemCore(product, cartOrCheckout);
        }
    }
};

function DecrementItemCore(product, cartOrCheckout, setQuantityByForce = false, byforceQuantity = 0) {
    const state = store.getState();
    if (state.itemCart.length > 0) {
        let record = state.itemCart.find(x => x.itemID === product.itemID);
        if (record) {
            if (record.quantity <= record.minQty && !setQuantityByForce) {
                RemoveItem(product);
            } else {
                let newRecord = {
                    itemID: product.itemID,
                    quantity: !setQuantityByForce ? (record.quantity * 10 - record.slabQty * 10) / 10 : byforceQuantity,
                    itemName: record.itemName,
                    amount: record.amount,
                    itemTotal: !setQuantityByForce ? record.itemTotal - ((record.slabQty / 1) * record.amount) : byforceQuantity * record.amount,
                    itemImage: record.itemImage,
                    minQty: record.minQty,
                    maxQty: record.maxQty,
                    slabQty: record.slabQty,
                    discountValue: record.discountValue,
                    promoDetails: record.promoDetails,
                    discountedTotal: record.discountedTotal,
                    uom: record.uom,
                    isAvailable: record.isAvailable,
                    stockInHand: record.stockInHand,
                    isSellingToday: record.isSellingToday,
                    departmentCode: product.departmentCode,
                    subDepartmentCode: product.subDepartmentCode,
                    categoryCode: product.categoryCode,
                    merchantID: product.merchantID,
                    itemCode: product.itemCode
                }

                if (newRecord.quantity <= 0) {
                    RemoveItem(product);
                } else {
                    var updatedResult = state.itemCart;

                    CalculatePromotion(newRecord, state.promotionItems, state.userDetails, (result) => {
                        if (result) { updatedResult[state.itemCart.indexOf(record)] = result; }
                        else { updatedResult[state.itemCart.indexOf(record)] = newRecord; }
                        store.dispatch(resetItemCart());
                        store.dispatch(updateItemCart(updatedResult));
                    });
                    //UpdateCosmosDB();
                    RemoveItemFromCartEvent(newRecord)
                    RemoveItemFromCartEventGA4(newRecord, state.shoppingPreference.outletCode)
                }
            }
        }
        if (cartOrCheckout == true && state.nexusRedemption.isRedeemed) {
            DispatchCalculation(state.calculatedPromotionResult);
        }
        else if (cartOrCheckout == true && !state.nexusRedemption.isRedeemed) {
            CalculateOrderDiscount();
        }
        CheckIfFullNexusCheckout();
    }
}

/**
 * Date     :   2020-07-02
 * Remark   :   Remove product from the cart
 * @param {*} product 
 */
export function RemoveItem(product, cartOrCheckout, continueWithoutConfirmation) {
    const state = store.getState();
    if (state.itemCart.length === 1) {
        store.dispatch(jkoaPurchaseNo());
    }
    if (state.nexusRedemption.isRedeemed && cartOrCheckout) {
        //NexusReverseForCart(RemoveItemCore.bind(null, product, cartOrCheckout));
        CheckNexusReversal(RemoveItemCore.bind(null, product, cartOrCheckout), product, continueWithoutConfirmation, true);
    } else {
        RemoveItemCore(product, cartOrCheckout);
    }
};

function RemoveItemCore(product, cartOrCheckout) {
    const state = store.getState();
    const result = state.itemCart.filter(x => x.itemID != product.itemID);
    store.dispatch(removeItemFromCart(result));

    decrypt(state.userDetails.mobileNumber).then((decryptedMobileNumber)=>{
        if ((newNexusRegistrationCodeEnum.newNexusRegistrationCode === product.itemID) && (decryptedMobileNumber === state.loyaltyRegistrationDetail.mobileNumber)) {
        store.dispatch(
            updateIsNexusFlag(false),
            resetLoyaltyRegistrationDetail(),
        ).then(() => {
            refreshCartOnNexusFlagChanged();
        });
    }

    if (cartOrCheckout == true && state.nexusRedemption.isRedeemed) {
        DispatchCalculation(state.calculatedPromotionResult);
    }
    else if (cartOrCheckout == true && !state.nexusRedemption.isRedeemed) {
        CalculateOrderDiscount();
    }

    UpdateCosmosDB();
    CheckIfFullNexusCheckout();
    RemoveItemFromCartEvent(product);
    RemoveItemFromCartEventGA4(product, state.shoppingPreference.outletCode)
    })

    
}

export function RemoveMultipleItems(toBeRemovedProductList) {
    const state = store.getState();
    if (state.nexusRedemption.isRedeemed) {
        //NexusReverseForCart(RemoveItemCore.bind(null, product, cartOrCheckout));
        CheckNexusReversalMultipleItems(RemoveMultipleItemsCore.bind(null, toBeRemovedProductList), toBeRemovedProductList, true);
    } else {
        RemoveMultipleItemsCore(toBeRemovedProductList);
    }
};

function RemoveMultipleItemsCore(productList) {
    const state = store.getState();
    var notToRemove = state.itemCart.filter(function (itm) {
        let record = productList.find(x => x.itemID === itm.itemID);
        if (!record) {
            return itm;
        }
    });
    store.dispatch(removeItemFromCart(notToRemove));

    let product = productList.find(x => x.itemID === newNexusRegistrationCodeEnum.newNexusRegistrationCod);

    decrypt(state.userDetails.mobileNumber).then((decryptedMobileNumber)=>{
        if (product) {
        if ((newNexusRegistrationCodeEnum.newNexusRegistrationCode === product.itemID) && (decryptedMobileNumber === state.nexusRegistrationDetail.mobileNumber)) {
            store.dispatch(
                updateIsNexusFlag(false),
                resetNexusRegistrationDetail(),
                resetLoyaltyRegistrationDetail()
            ).then(() => {
                refreshCartOnNexusFlagChanged();
            });
        }
    }

    if (state.nexusRedemption.isRedeemed) {
        DispatchCalculation(state.calculatedPromotionResult);
    }
    else if (!state.nexusRedemption.isRedeemed) {
        CalculateOrderDiscount();
    }

    UpdateCosmosDB();
    CheckIfFullNexusCheckout();
    })

    
}

/**
 * Date     :   2021-12-08
 * Remark   :   forcefully set product quantity from the cart
 * @param {*} product 
 */
export function FrocefullySetQuantities(productList) {
    const state = store.getState();
    let product;
    let stockInHand;
    productList.map(elm => {
        product = state.itemCart.find(x => x.itemID === elm.itemId);
        stockInHand = elm.stockInHand;
        DecrementItemCore(product, false, true, stockInHand);
    });

    DecrementItemCore(product, true, true, stockInHand);
};

//this method is obselete
function NexusReverseForCart(callback) {
    let messageBox = {
        show: true,
        title: "Warning",
        className: "warning",
        content: "You have made a Keells Nexus point redemption.\nRemoving an item after Keells Nexus point redemption will cause the redemption to be reversed.\nDo you want to update the cart and reverse the Keells Nexus point redemption ?",
        isConfirmation: true,
        callBackFunction: (result) => {
            if (result) {
                //do nexus reversal and item removal
                store.dispatch(showLoadingScreen());
                const state = store.getState();
                let body = {
                    TransactionReference: state.nexusRedemption.transactionReference,
                    NexusReference: state.nexusRedemption.nexusReference
                }
                post("/Order/ReverseNexusRedemption", body).then(response => {
                    //check response data exist
                    if (response.status == 200) {
                        //check function is succeeded
                        if (response.data.errorList[0]["errorType"] == 4) {
                            store.dispatch(resetNexusRedemption());
                            store.dispatch(hideLoadingScreen());
                            if (typeof (callback) === typeof (Function)) {
                                callback();
                            }
                        }
                        else {
                            store.dispatch(hideLoadingScreen());
                            let messageBox = {
                                show: true,
                                title: "ERROR",
                                className: "error",
                                content: response.data.errorList[0]["statusMessage"],
                                isConfirmation: false,
                                callBackFunction: () => { }
                            }
                            store.dispatch(showMessageBox(messageBox));
                        }
                    }
                })
            }
        }
    }
    store.dispatch(showMessageBox(messageBox));
}

function CheckNexusReversal(callback, product, continueWithoutConfirmation, directRemove) {
    const state = store.getState();
    let _ItemList = [];
    let _pickupDateTime = null;

    if (state.itemCart.length > 0) {

        decrypt(state.userDetails.customerID).then((decryptedID)=>{
            let record = state.itemCart.find(x => x.itemID === product.itemID);
        if (record) {
            //Create the order object
            state.itemCart.forEach(prod => {
                let addItem = true;
                let _Quantity = null;
                let _Amount = null;
                if (prod.itemID === record.itemID) {
                    if (directRemove == true) {
                        addItem = false;
                    }
                    else if (record.quantity <= record.minQty) {
                        addItem = false;
                    } else {
                        let newRecord = {
                            itemID: product.itemID,
                            quantity: (record.quantity * 10 - record.slabQty * 10) / 10,
                            itemName: record.itemName,
                            amount: record.amount,
                            itemTotal: record.itemTotal - ((record.slabQty / 1) * record.amount),
                            itemImage: record.itemImage,
                            minQty: record.minQty,
                            maxQty: record.maxQty,
                            slabQty: record.slabQty,
                            discountValue: record.discountValue,
                            promoDetails: record.promoDetails,
                            discountedTotal: record.discountedTotal,
                            uom: record.uom,
                            isAvailable: record.isAvailable,
                            stockInHand: record.stockInHand,
                            isSellingToday: record.isSellingToday,
                            departmentCode: product.departmentCode,
                            subDepartmentCode: product.subDepartmentCode,
                            categoryCode: product.categoryCode,
                            merchantID: product.merchantID
                        }

                        if (newRecord.quantity < 0) {
                            addItem = false;
                        } else {
                            _Quantity = newRecord.quantity;
                            _Amount = newRecord.itemTotal;
                        }
                    }
                }

                if (addItem) {
                    _ItemList.push({
                        ItemId: prod.itemID,
                        Quantity: _Quantity === null ? prod.quantity : _Quantity,
                        UnitPrice: prod.amount,
                        Amount: _Amount === null ? prod.itemTotal : _Amount,
                        DiscountValue: prod.discountValue,
                        PromoDetails: prod.promoDetails
                    })
                }
            });

            let orderData = {
                OrderNumber: "",
                ContactNumber: "",
                AddressLine1: "",
                AddressLine2: "",
                City: "",
                LocationCode: state.shoppingPreference.outletCode,
                PayMode: "",
                PayModeId: 0,
                IsCardPaymentRetry: false,
                ItemList: _ItemList,
                TotalAmount: 0,
                PickupDateTime: _pickupDateTime,
                DeliveryType: state.shoppingPreference.shoppingMethod === 'Pickup' ? 2 : 1,
                RefundOptionID: 0,
                CustomerID: decryptedID,
                SuburbID: state.shoppingPreference.suburbID,
                Comment: "",
                RecipientName: ""
            }
            CompareNexusRedemptionValue(callback, orderData, continueWithoutConfirmation, state);
        }
        })
        
    }
}

function CheckNexusReversalMultipleItems(callback, productList, continueWithoutConfirmation) {
    const state = store.getState();
    let _ItemList = [];
    let _pickupDateTime = null;

    if (state.itemCart.length > 0) {

        var notToRemove = state.itemCart.filter(function (itm) {
            let record = productList.find(x => x.itemID === itm.itemID);
            if (!record) {
                return itm;
            }
        });

        notToRemove.forEach(prod => {
            _ItemList.push({
                ItemId: prod.itemID,
                Quantity: prod.quantity,
                UnitPrice: prod.amount,
                Amount: prod.itemTotal,
                DiscountValue: prod.discountValue,
                PromoDetails: prod.promoDetails
            })
        });

        decrypt(state.userDetails.customerID).then((decryptedID)=>{
            let orderData = {
            OrderNumber: "",
            ContactNumber: "",
            AddressLine1: "",
            AddressLine2: "",
            City: "",
            LocationCode: state.shoppingPreference.outletCode,
            PayMode: "",
            PayModeId: 0,
            IsCardPaymentRetry: false,
            ItemList: _ItemList,
            TotalAmount: 0,
            PickupDateTime: _pickupDateTime,
            DeliveryType: state.shoppingPreference.shoppingMethod === 'Pickup' ? 2 : 1,
            RefundOptionID: 0,
            CustomerID: decryptedID,
            SuburbID: state.shoppingPreference.suburbID,
            Comment: "",
            RecipientName: ""
        }
        CompareNexusRedemptionValue(callback, orderData, continueWithoutConfirmation, state);
        })
        
    }
}

function CompareNexusRedemptionValue(callback, orderData, continueWithoutConfirmation, state) {
    store.dispatch(showLoadingScreen());
    post("/Order/CalculateOrderDiscount", orderData).then(response => {
        //check response data exist
        if (response.status == 200) {
            //check function is succeeded
            if (response.data.errorList[0]["errorType"] == 4) {
                let deliveryCharge = 0;

                if (state.shoppingPreference.shoppingMethod === shoppingMethod.delivery) {
                    deliveryCharge = state.webDataCollection.systemConfiguration.orderDeliveryCharge;
                }

                if ((state.nexusRedemption.isRedeemed ? state.nexusRedemption.redeemedAmount : 0) > (response.data.result.netTotal + deliveryCharge)) {
                    let msgContent = "";
                    if (continueWithoutConfirmation == true) {
                        msgContent = "After you remove this item, cart value go less than redeemed amount. Then the balance value will reversed after your order completion.";
                    } else {
                        msgContent = "After you remove this item, cart value go less than redeemed amount. If so balance value will reversed after your order completion. Do you want to continue to remove the item?";
                    }
                    if (!state.nexusRedemption.isNexusRedeemedAmountCartValueComparisonAcknowledged) {
                        let messageBox = {
                            show: true,
                            title: "Warning",
                            className: "warning",
                            content: msgContent,
                            isConfirmation: continueWithoutConfirmation == true ? false : true,
                            callBackFunction: (result) => {
                                if (result) {
                                    if (typeof (callback) === typeof (Function)) {
                                        store.dispatch(resetCalculatedPromotionResult());
                                        store.dispatch(addCalculatedPromotionResult(response.data.result));
                                        store.dispatch(updateNexusRedeemedAmountCartValueComparisonAcknowledge(true));
                                        callback();
                                    }
                                }
                            }
                        }

                        store.dispatch(showMessageBox(messageBox));
                    }
                    else {
                        if (typeof (callback) === typeof (Function)) {
                            store.dispatch(resetCalculatedPromotionResult())
                            store.dispatch(addCalculatedPromotionResult(response.data.result))
                            callback();
                        }
                    }
                } else {
                    if (typeof (callback) === typeof (Function)) {
                        store.dispatch(resetCalculatedPromotionResult())
                        store.dispatch(addCalculatedPromotionResult(response.data.result))
                        callback();
                    }
                }
            }
        }
        store.dispatch(hideLoadingScreen());
    })
}

export function CheckIfFullNexusCheckout(promoCodeDiscountedAmount = 0) {
    const state = store.getState();
    let totalCartAmount = Number(parseFloat(ItemFinalTotalDecimal(state.shoppingPreference.shoppingMethod, promoCodeDiscountedAmount)).toFixed(2));
    let redemptionAmount = Number(parseFloat(state.nexusRedemption.redeemedAmount).toFixed(2));
    if (redemptionAmount >= (totalCartAmount)) {
        let data = {
            isFullNexusCheckout: true
        }
        store.dispatch(updateFullNexusCheckout(data));
    } else {
        let data = {
            isFullNexusCheckout: false
        }
        store.dispatch(updateFullNexusCheckout(data));
    }
}

/**
 * Date     :   2020-07-02
 * Remark   :   Calculate promotions for products
 * @param {*} cartItem 
 * @param {*} promotionItems 
 * @param {*} userDetail 
 * @param {*} callBack 
 */
export function CalculatePromotion(cartItem, promotionItems, userDetail, callBack) {
    let discount = 0;
    let promoDetails = [];
    let promos = promotionItems.filter(x => x.itemID === cartItem.itemID && !x.alreadyObtainedByCustomer);
    if (promos.length > 0) {
        //Restrict nexus deals only for nexus members
        if (promos[0].otherPromotionTypeID === otherPromotionTypesEnum.NexusDeals) {
            if (userDetail.isNexus) {
                promos.map(elm => {
                    //greater than or equal to minimum promo qty
                    if (elm.minimumQuantity <= cartItem.quantity) {
                        //les than or equal to max promo qty
                        if (cartItem.quantity <= elm.maximumQuantity) {
                            //discount for all quantity
                            //percentage
                            if (elm.isPercentagePromotion) {
                                let itemDis = ((cartItem.amount / 100.00) * elm.discountPercentage);
                                let lineDis = Math.ceil(itemDis * cartItem.quantity);
                                discount += lineDis;
                                promoDetails.push({
                                    promotionDetailID: elm.promotionDetailID,
                                    promoDiscount: lineDis,
                                    promoAppliedQuantity: cartItem.quantity,
                                    otherPromotionTypeID: elm.otherPromotionTypeID
                                });
                            }
                            //value
                            else if (elm.isValuePromotion) {
                                let lineDis = elm.discountValue * cartItem.quantity;
                                discount += lineDis;
                                promoDetails.push({
                                    promotionDetailID: elm.promotionDetailID,
                                    promoDiscount: lineDis,
                                    promoAppliedQuantity: cartItem.quantity,
                                    otherPromotionTypeID: elm.otherPromotionTypeID
                                });
                            }
                        } else {
                            //discount for maximum quantity only
                            //percentage
                            if (elm.isPercentagePromotion) {
                                let itemDis = ((cartItem.amount / 100.00) * elm.discountPercentage);
                                let lineDis = Math.ceil(itemDis * elm.maximumQuantity);
                                discount += lineDis;
                                promoDetails.push({
                                    promotionDetailID: elm.promotionDetailID,
                                    promoDiscount: lineDis,
                                    promoAppliedQuantity: elm.maximumQuantity,
                                    otherPromotionTypeID: elm.otherPromotionTypeID
                                });
                            }
                            //value
                            else if (elm.isValuePromotion) {
                                let lineDis = elm.discountValue * elm.maximumQuantity;
                                discount += lineDis;
                                promoDetails.push({
                                    promotionDetailID: elm.promotionDetailID,
                                    promoDiscount: lineDis,
                                    promoAppliedQuantity: elm.maximumQuantity,
                                    otherPromotionTypeID: elm.otherPromotionTypeID
                                });
                            }
                        }
                    }
                });
            }
        } else if (!promos[0].checkPaymentMode) {
            promos.map(elm => {
                //greater than or equal to minimum promo qty
                if (elm.minimumQuantity <= cartItem.quantity) {
                    //les than or equal to max promo qty
                    if (cartItem.quantity <= elm.maximumQuantity) {
                        //discount for all quantity
                        //percentage
                        if (elm.isPercentagePromotion) {
                            let itemDis = ((cartItem.amount / 100.00) * elm.discountPercentage);
                            let lineDis = Math.ceil(itemDis * cartItem.quantity);
                            discount += lineDis;
                            promoDetails.push({
                                promotionDetailID: elm.promotionDetailID,
                                promoDiscount: lineDis,
                                promoAppliedQuantity: cartItem.quantity,
                                otherPromotionTypeID: elm.otherPromotionTypeID
                            });
                        }
                        //value
                        else if (elm.isValuePromotion) {
                            let lineDis = elm.discountValue * cartItem.quantity;
                            discount += lineDis;
                            promoDetails.push({
                                promotionDetailID: elm.promotionDetailID,
                                promoDiscount: lineDis,
                                promoAppliedQuantity: cartItem.quantity,
                                otherPromotionTypeID: elm.otherPromotionTypeID
                            });
                        }
                    } else {
                        //discount for maximum quantity only
                        //percentage
                        if (elm.isPercentagePromotion) {
                            let itemDis = ((cartItem.amount / 100.00) * elm.discountPercentage);
                            let lineDis = Math.ceil(itemDis * elm.maximumQuantity);
                            discount += lineDis;
                            promoDetails.push({
                                promotionDetailID: elm.promotionDetailID,
                                promoDiscount: lineDis,
                                promoAppliedQuantity: elm.maximumQuantity,
                                otherPromotionTypeID: elm.otherPromotionTypeID
                            });
                        }
                        //value
                        else if (elm.isValuePromotion) {
                            let lineDis = elm.discountValue * elm.maximumQuantity;
                            discount += lineDis;
                            promoDetails.push({
                                promotionDetailID: elm.promotionDetailID,
                                promoDiscount: lineDis,
                                promoAppliedQuantity: elm.maximumQuantity,
                                otherPromotionTypeID: elm.otherPromotionTypeID
                            });
                        }
                    }
                }
            });
        }
    }

    cartItem.discountValue = discount;
    if (cartItem.promoDetails.length === 0) { cartItem.promoDetails = promoDetails; }
    else { cartItem.promoDetails.concat(promoDetails); }
    cartItem.discountedTotal = (cartItem.amount * cartItem.quantity) - discount;
    cartItem.itemTotal = (cartItem.amount * cartItem.quantity);
    callBack(cartItem);

};

/**
 * Author   :   Nuwan Danthanarayana
 * Date     :   2020-08-11
 * Remark   :   To caculate the promotions
 */
export function CalculateOrderDiscount() {
    const state = store.getState();
    let _ItemList = [];
    let _pickupDateTime = null;

    state.itemCart.forEach(product => {
        _ItemList.push({
            ItemId: product.itemID,
            Quantity: product.quantity,
            UnitPrice: product.amount,
            Amount: product.itemTotal,
            DiscountValue: product.discountValue,
            PromoDetails: product.promoDetails
        })
    });

    decrypt(state.userDetails.customerID).then((decryptedID)=>{
        let orderData = {
        OrderNumber: "",
        ContactNumber: "",
        AddressLine1: "",
        AddressLine2: "",
        City: "",
        LocationCode: state.shoppingPreference.outletCode,
        PayMode: "",
        PayModeId: 0,
        IsCardPaymentRetry: false,
        ItemList: _ItemList,
        TotalAmount: 0,
        PickupDateTime: _pickupDateTime,
        DeliveryType: state.shoppingPreference.shoppingMethod === 'Pickup' ? 2 : 1,
        RefundOptionID: 0,
        CustomerID: decryptedID,
        SuburbID: state.shoppingPreference.suburbID,
        Comment: "",
        RecipientName: ""
    }
    store.dispatch(showLoadingScreen());
    post("/Order/CalculateOrderDiscount", orderData).then(response => {
        //check response data exist
        if (response.status == 200) {
            //check function is succeeded
            if (response.data.errorList[0]["errorType"] == 4) {
                if (response.data.result.order.orderPromotionsList) {
                    DispatchCalculation(response.data.result)
                }
            }
        }
        store.dispatch(hideLoadingScreen());
    })
    });
    
};

function DispatchCalculation(calculatedResult) {
    if (calculatedResult) {
        store.dispatch(resetPromotionItems());
        if (calculatedResult[0]) {
            store.dispatch(addPromotionItems(calculatedResult[0].itemPromoDetails));
            store.dispatch(setOrderPromotionDetails(calculatedResult[0].order.orderPromotionsList ? calculatedResult[0].order.orderPromotionsList : []));
            store.dispatch(setOrderFreeIssuePromotionDetails(calculatedResult[0].order.orderFreeIssuePromotionList ? calculatedResult[0].order.orderFreeIssuePromotionList : []));
        } else {
            store.dispatch(addPromotionItems(calculatedResult.itemPromoDetails));
            store.dispatch(setOrderPromotionDetails(calculatedResult.order.orderPromotionsList ? calculatedResult.order.orderPromotionsList : []));
            store.dispatch(setOrderFreeIssuePromotionDetails(calculatedResult.order.orderFreeIssuePromotionList ? calculatedResult.order.orderFreeIssuePromotionList : []));
        }

        RemoveAllItemPromotions();
    } else {
        store.dispatch(setOrderPromotionDetails([]));
        store.dispatch(setOrderFreeIssuePromotionDetails([]));
    }
}

function RemoveAllItemPromotions() {
    const state = store.getState();
    if (state.itemCart.length > 0) {
        let promotionRemovedList = [];

        state.itemCart.map(item => {
            let promoRemovedItem = item;

            promoRemovedItem.name = promoRemovedItem.itemName;
            promoRemovedItem.imageUrl = promoRemovedItem.itemImage;
            promoRemovedItem.promoDetails = [];

            promotionRemovedList.push(promoRemovedItem);
        })

        AddRecoveryCartItemToCart(promotionRemovedList, true, () => { });
    }
}

/**
 * Author   :   Dinushka Rukshan
 * Date     :   2020-07-02
 * Remark   :   Common function to add save carts & past orders to cart
 */
export function AddProductListToCart(productList,pageId) {
    const state = store.getState();
    if (state.itemCart.length > 0) {
        productList.map(product => {
            if (!(newNexusRegistrationCodeEnum.newNexusRegistrationCode.toString() === product.itemCode)) {
                let exist = state.itemCart.find(item => item.itemID === product.itemID);
                if (exist) {
                    let replaceExist = {
                        itemID: product.itemID,
                        quantity: (exist.quantity * 10 + product.quantity * 10) / 10,
                        itemName: exist.itemName,
                        amount: product.amount,
                        itemTotal: (product.quantity * product.amount) + exist.itemTotal,
                        itemImage: exist.itemImage,
                        minQty: product.minQty > 0 ? product.minQty : 1,
                        maxQty: product.maxQty > 0 ? product.maxQty : 999,
                        slabQty: product.slabQty > 0 ? product.slabQty : 1,
                        discountValue: exist.discountValue,
                        promoDetails: exist.promoDetails,
                        discountedTotal: exist.discountedTotal,
                        uom: exist.uom,
                        isAvailable: exist.isAvailable,
                        stockInHand: exist.stockInHand,
                        isSellingToday: exist.isSellingToday,
                        departmentCode: product.departmentCode,
                        subDepartmentCode: product.subDepartmentCode,
                        categoryCode: product.categoryCode,
                        merchantID: product.merchantID,
                        itemCode: product.itemCode
                    }
                    var updatedResult = state.itemCart;
                    CalculatePromotion(replaceExist, state.promotionItems, state.userDetails, (result) => {
                        if (result) { updatedResult[state.itemCart.indexOf(exist)] = result; }
                        else { updatedResult[state.itemCart.indexOf(exist)] = replaceExist; }
                        store.dispatch(resetItemCart());
                        store.dispatch(updateItemCart(updatedResult));

                        UpdateCosmosDB();
                    });
                }
                else { AddNewItem(product,pageId) }
            }
        })
    } else {
        AddRecoveryCartItemToCart(productList, false, () => { });
    }
};

/** 
 * Date     :   2020-06-27
 * Remark   :   Function to add the recovery cart items to cart
 * @param {*} productList 
 */
export function AddRecoveryCartItemToCart(productList, addNexusCard, callback) {
    store.dispatch(resetItemCart());
    const state = store.getState();
    let count = 0;
    for (let item of productList) {
        if (Object.values(JKOAMerchantTypes).includes(item.merchantID)) {
            count++
        }
    }
    if (count > 0) {
        if (count === productList.length) {
            store.dispatch(jkoaPurchaseYes());
            if (state.shoppingPreference.shoppingMethod === shoppingMethod.pickup) {
                //Set JKOA Purchase state to "false"(To avoid mixing Keells and JKOA cart items) 
                store.dispatch(jkoaPurchaseNo());
                let messageBox = {
                    show: true,
                    title: "Oops!",
                    className: "error",
                    content: "you can't select electronic item in pick up order. So you can't use the previous seleceted item",
                    isConfirmation: false,
                    callBackFunction: null
                }
                store.dispatch(showMessageBox(messageBox));
                return;
            }
        } else {
            store.dispatch(jkoaPurchaseNo());
            let messageBox = {
                show: true,
                title: "Oops!",
                className: "error",
                content: "you can't buy electronic items and grocery items in same purchase. So you can't use the previous seleceted item",
                isConfirmation: false,
                callBackFunction: null
            }
            store.dispatch(showMessageBox(messageBox));
            return;
        }
    }

    productList.map(product => {
        let isAddItem = addNexusCard ? addNexusCard : !(newNexusRegistrationCodeEnum.newNexusRegistrationCode.toString() === product.itemCode);
        if (isAddItem) {
            let tempMinQty = product.minQty > 0 ? product.minQty : 1;
            let list = {
                itemID: product.itemID,
                quantity: product.quantity === 0 ? 1 : product.quantity,
                itemName: product.name,
                amount: product.amount,
                itemTotal: (tempMinQty / 1) * product.amount,
                itemImage: product.imageUrl,
                minQty: product.minQty > 0 ? product.minQty : 1,
                maxQty: product.maxQty > 0 ? product.maxQty : 999,
                slabQty: product.slabQty > 0 ? product.slabQty : 1,
                discountValue: 0,
                promoDetails: [],
                discountedTotal: (tempMinQty / 1) * product.amount,
                uom: product.uom === "KG" ? product.uom : "Unit",
                isAvailable: product.isAvailable,
                stockInHand: product.stockInHand,
                isSellingToday: product.isSellingToday,
                departmentCode: product.departmentCode,
                subDepartmentCode: product.subDepartmentCode,
                categoryCode: product.categoryCode,
                merchantID: product.merchantID,
                itemCode: product.itemCode
            }

            CalculatePromotion(list, state.promotionItems, state.userDetails, (result) => {
                if (result) { store.dispatch(addItemToCart(result)); }
                else { store.dispatch(addItemToCart(list)); }
            });
        }
    })
    callback();
};

/**
 * Date     :   2020-06-27
 * Remark   :   Reset recovery cart on cosmos DB
 */
export function ResetTemporarySavedCart() {
    //Clear Cosmos DB
    UpdateCosmosDB(true);
};

/**
 * Author   :   Nuwan Danthanarayana
 * Date     :   2020-07-10
 * Remark   :   Common function to update item cart in cosmos db
 */
export function UpdateCosmosDB(isDeleteAll, isSaveAll) {
    const state = store.getState();
    if (state.webDataCollection.systemConfiguration.temporySaveItemEnabled) {
        if (isDeleteAll || state.itemCart.length % state.webDataCollection.systemConfiguration.temporySaveItemCountFrequency === 0 || isSaveAll) {
            
            decrypt(state.userDetails.customerID).then((decryptedID)=>{
                let dataObJect = [];
            if (!isDeleteAll && state.itemCart.length > 0) {
                state.itemCart.map(product => {
                    dataObJect.push({
                        "id": decryptedID + '_' + product.itemID,
                        "itemID": product.itemID,
                        "customerID": decryptedID,
                        "quantity": product.quantity
                    });
                });
            } else {
                dataObJect.push({
                    "id": '',
                    "itemID": '',
                    "customerID": decryptedID,
                    "quantity": ''
                });
            }

            try {
                fetch(CART_ITEM_FUNCTIONS_URL + CART_ITEM_HANDLE_URI, {
                    method: 'POST', // *GET, POST, PUT, DELETE, etc.
                    mode: 'no-cors', // no-cors, *cors, same-origin
                    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
                    credentials: 'same-origin', // include, *same-origin, omit
                    headers: {
                        'Content-Type': 'application/json'
                        // 'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    redirect: 'follow', // manual, *follow, error
                    referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
                    body: JSON.stringify(dataObJect) // body data type must match "Content-Type" header
                });
            } catch (er) { }

            // let url = CART_ITEM_FUNCTIONS_URL + CART_ITEM_SAVE_URI +
            //     '&id=' + state.userDetails.customerID + '_' + product.itemID + '&itemID=' + product.itemID + '&customerID=' + state.userDetails.customerID + '&quantity=' + list.quantity;
            // try {
            //     fetch(url)
            //         .then(res => res.json())
            //         .then((result) => { },
            //             // Note: it's important to handle errors here
            //             // instead of a catch() block so that we don't swallow
            //             // exceptions from actual bugs in components.
            //             (error) => { })
            // } catch (er) {  }
            });

                    
        }
    }
}

/*-- Payment regarding functions --*/
export const SetupCardPayment = (
    paymentDetails,
    paymentMethod,
    totalAmount,
    orderTypeID,
    createToken,
    isSaveCard,
    sessionID,
    callback
) => {
    const isHybridApp = isReactNativeWebView();

    if (paymentDetails.orderNumber === undefined) {
        localStorage.setItem(LocalStorageEnum.OrderNumber, paymentDetails.reference_number);
    } else {
        localStorage.setItem(LocalStorageEnum.OrderNumber, paymentDetails.orderNumber);
    }

    if (paymentMethod === PaymentMethods.VisaMaster) {

        const form = document.createElement("form");
        form.method = "POST";
        form.action = createToken === true ? CyberSource_Token_Create_URL : CyberSource_URL;

        let body = '';
        paymentDetails.signed_field_names.split(',').forEach(key => {
            body += `<input type="hidden" name="${key}" value="${paymentDetails[key]}" />`;
        });
        body += `<input type="hidden" name="signature" value="${paymentDetails.signature}" />`;

        form.innerHTML = body;
        document.body.appendChild(form);

        // Delay added for Payment Gateway Timed out issue.
        if (isHybridApp) {
            setTimeout(() => {
                form.submit();
            }, 2000);
        } else {
        form.submit();
    }

    } else if (paymentMethod === PaymentMethods.Amex) {

        localStorage.setItem(LocalStorageEnum.OrderTotal, totalAmount);
        localStorage.setItem(LocalStorageEnum.AMEXSessionID, paymentDetails.sessionID);
        localStorage.setItem(LocalStorageEnum.IsSaveCard, isSaveCard);
        localStorage.setItem(LocalStorageEnum.SessionID, sessionID);

        callback(true);
    }
};

export const CardPaymentDone = (
    props,
    params,
    orderTypeID,
    callback,
    isDeepLinkFallback = false
) => {

    const code = params?.code || "";
    const parts = code.split("~");

    const status = parts[0] || "";
    const orderNumber = parts[1] || "";
    const responseCode = parts[2] || "";
    const paymentModeID = parts[3] || "";
    let SourceChannel = hybridAppSourceChannelEnum.Web;

    if (orderNumber && responseCode) {
        if (orderNumber.includes(orderPrefixes.UtilityBillPayment)) {
            SourceChannel = parts[4] || hybridAppSourceChannelEnum.Web;
        } else {
            SourceChannel = parts[3] || hybridAppSourceChannelEnum.Web;
        }
    }

    // console.log('status', status);
    // console.log('orderNumber', orderNumber);
    // console.log('responseCode', responseCode);
    // console.log('paymentModeID', paymentModeID);
    // console.log('SourceChannel', SourceChannel);
    
    // ------------------ TRY HYBRID DEEP LINK -----------------------
    if (!isDeepLinkFallback && SourceChannel === hybridAppSourceChannelEnum.HybridApp) {

        // Only trigger deep link if params look valid
        if (orderNumber && responseCode) {
            const isUtilityPayment = orderNumber.includes(orderPrefixes.UtilityBillPayment);
            let deeplink = `keellshybridapp://hybrid-app/checkout/card-payment/${status}~${orderNumber}~${responseCode}`;

            if (isUtilityPayment) {
                deeplink = `keellshybridapp://utilitypaymentscompleted/${status}~${orderNumber}~${responseCode}~${paymentModeID}`;
            }

            console.log("Attempting deep link:", deeplink);

            let didDeepLinkWork = false;

            const visibilityHandler = () => {
                didDeepLinkWork = true; // Deep link succeeded
                document.removeEventListener("visibilitychange", visibilityHandler);
            };
            document.addEventListener("visibilitychange", visibilityHandler);

            // Attempt deep link
            setTimeout(() => {
                window.location.href = deeplink;
            }, 50);

            // Fallback after 800ms
            setTimeout(() => {
                if (!didDeepLinkWork) {
                    console.log("Deep link failed → using website fallback");
                    CardPaymentDone(props, params, orderTypeID, callback, true);
                }
            }, 800);

            // Stop execution -> wait for fallback or success
            return;
        }
    }

    let _paymentFailedMessage = '';

    if (params?.code) {
        let isError = false;

        try {
            const statusCode = params.code.split('~')[0];
            const orderRef = params.code.split('~')[1];

            // -------- SUCCESS 1 --------
            if (statusCode === '1') {
                if (orderRef.includes(orderPrefixes.UtilityBillPayment)) {

                    if (params.code.split('~')[3] == DonationData.PaymentModeID) {
                        window.location.href = `/thankyou/${orderRef}/6/`;
                    }
                    else {
                        window.location.href = `/thankyou/${orderRef}/2`;
                    }

                } else {
                    window.location.href = `/thankyou/${orderRef}/1`;
                }
            }

            // -------- FAILURE 0 --------
            else if (statusCode === '0') {
                const resp = `${params.code.split('~')[2]}`;

                switch (resp) {
                    case '110': _paymentFailedMessage = 'Only a partial amount was approved.'; break;
                    case '150':
                    case '236':
                    case '152': _paymentFailedMessage = `Card payment failed. Please re check your balance before retry.(Order Reference : ${orderRef})`; break;
                    case '202': _paymentFailedMessage = 'Expired card or incorrect expiration date.'; break;
                    case '204': _paymentFailedMessage = 'Insufficient funds.'; break;
                    case '205': _paymentFailedMessage = 'Stolen or lost card.'; break;
                    case '208': _paymentFailedMessage = 'Inactive or unauthorized card.'; break;
                    case '210': _paymentFailedMessage = 'Credit limit reached.'; break;
                    case '211': _paymentFailedMessage = 'Invalid CVN.'; break;
                    case '222': _paymentFailedMessage = 'Account frozen.'; break;
                    case '231': _paymentFailedMessage = 'Invalid account number.'; break;
                    case '481': _paymentFailedMessage = 'Incorrect card type for promotion.'; break;
                    case '490':
                    case '491': _paymentFailedMessage = 'Foreign currency transactions not enabled.'; break;
                    case 'UC': _paymentFailedMessage = 'Your payment was cancelled successfully.'; break;
                    case 'NF': _paymentFailedMessage = 'Order does not exist.'; break;
                    case 'CO': _paymentFailedMessage = 'Order already generated.'; break;

                    // AMEX Errors
                    case '35': _paymentFailedMessage = 'Card payment FAILURE.'; break;
                    case '68': _paymentFailedMessage = 'Payment Gateway TIMED OUT'; break;
                    case '05': _paymentFailedMessage = 'Bank declined the payment'; break;
                    case '54': _paymentFailedMessage = 'Card expired.'; break;
                    case '14': _paymentFailedMessage = 'Invalid card number'; break;

                    default: _paymentFailedMessage = 'Your card payment has failed.'; break;
                }

                store.dispatch(hideLoadingScreen());
                callback(_paymentFailedMessage);
            }
        }

        catch (error) {
            console.error("Payment parsing error:", error);
            isError = true;
        }

        if (isError) {
            _paymentFailedMessage = 'Bad attempt. Do not try again';
            store.dispatch(hideLoadingScreen());
            callback(_paymentFailedMessage);
        }
    } else {
        callback('');
    }
};
/*-- End of payment regarding functions --*/

/**
 * Author   :   Dinushka Rukshan
 * Date     :   2020-06-27
 * Remark   :   Common function to check password complexity
 * @param {Password} password 
 */
export function checkPasswordComplexity(password) {
    var obj = {};
    obj.result = true;
    if (password === "" || password === null) {
        obj.result = false;
        obj.error = "Password is required.";
        return obj;
    } else {
        var number = /[0-9]/;
        var upperCase = /[A-Z]/;
        var lowerCase = /[a-z]/;
        var special = /[!|@|#|$|%|^|&|*|(|)|-|_]/;

        if (password.length >= 8) {
            var countUpper = 0;
            var countLower = 0;
            var countNumber = 0;
            var countSpecials = 0;

            for (var i = 0; i < password.length; i++) {
                if (upperCase.test(password[i]))
                    countUpper++;
                else if (lowerCase.test(password[i]))
                    countLower++;
                else if (number.test(password[i]))
                    countNumber++;
                else if (special.test(password[i]))
                    countSpecials++;
            }

            if (countUpper < 1 /*|| countLower < 2*/ || countNumber < 1 || countSpecials < 1) {
                obj.result = false;
                obj.error = "Password should contain at least one Uppercase, Numeric & Special character.";
                return obj;
            }

            return obj;

        } else {
            obj.result = false;
            obj.error = "Password required minimum 8 characters with one Uppercase, Numeric & Special character.";
            return obj;
        }
    }
};

/**
 * Author   :   Dinushka Rukshan
 * Date     :   2020-06-30
 * Remark   :   To Refresh the cart when is Nexus flag changed
 */
export function refreshCartOnNexusFlagChanged() {
    const state = store.getState();
    store.dispatch(showLoadingScreen());
    if (state.itemCart.length > 0) {
        const existCart = state.itemCart;
        store.dispatch(resetItemCart());
        existCart.map(product => {
            let tempMinQty = product.minQty > 0 ? product.minQty : 1;
            let list = {
                itemID: product.itemID,
                quantity: product.quantity,
                itemName: product.itemName,
                amount: product.amount,
                itemTotal: (tempMinQty / 1) * product.amount,
                itemImage: product.itemImage,
                minQty: product.minQty > 0 ? product.minQty : 1,
                maxQty: product.maxQty > 0 ? product.maxQty : 999,
                slabQty: product.slabQty > 0 ? product.slabQty : 1,
                discountValue: 0,
                promoDetails: [],
                discountedTotal: (tempMinQty / 1) * product.amount,
                uom: product.uom === "KG" ? product.uom : "Unit",
                isAvailable: product.isAvailable,
                stockInHand: product.stockInHand,
                isSellingToday: product.isSellingToday,
                departmentCode: product.departmentCode,
                subDepartmentCode: product.subDepartmentCode,
                categoryCode: product.categoryCode,
                merchantID: product.merchantID,
                itemCode: product.itemCode
            }

            CalculatePromotion(list, state.promotionItems, state.userDetails, (result) => {
                if (result) { store.dispatch(addItemToCart(result)); }
                else { store.dispatch(addItemToCart(list)); }
            });
        })
    }
    store.dispatch(hideLoadingScreen());
};

/**
 * Date     :   2020-07-02
 * Remark   :   Check guest login
 * @param {*} callback 
 */
export function CheckGuestLogin(callback) {
    const state = store.getState();
    const isHybridApp = isReactNativeWebView();
    if (state.userDetails.isGuest) {
        let messageBox = {
            show: true,
            title: "Guest Login",
            className: "warning",
            content: "Thank you for choosing to shop at Keells Online.!\nPlease Login or Sign Up to proceed.",
            isConfirmation: true,
            callBackFunction: (result) => {
                if (result) {
                    window.location.replace("/welcome/Login");
                } else {
                    if (isHybridApp) {
                        window.location.replace("/hybrid-app/login");
                } else {
                    window.location.replace("/welcome/Registration");
                    }
                }
            }
        }
        store.dispatch(showMessageBox(messageBox));
        callback(true);
    }
    else {
        callback(false);
    }
};

export function CheckMobileAccessory(data) {
    const hostname = window && window.location && window.location.hostname;
    let flag = false;
    if (hostname === "www.keellssuper.com" || hostname === "keellssuper.com" || hostname === "staginglive.keellssuper.com") {
        if (data === "10") { flag = true; }
    }
    else if (hostname === "zebra.keellssuper.com") {
        if (data === "5") { flag = true; }
    }
    else if (hostname === "stagingzebra.keellssuper.com") {
        if (data === "10") { flag = true; }
    }
    else if (hostname === "localhost") {
        if (data === "5" || data === "10") { flag = true; }
    }
    if (data === "") { flag = true; }

    return flag;
}

export function getInitialDataCollection(callback= null) {
    store.dispatch(showLoadingScreen());
    const state = store.getState();
    let shippingDetailsId = state.shoppingPreference.shoppingMethod == shoppingMethod.delivery ? state.userDetails.shippingDetailsID : 0;
    return get(`/Web/GetInitialDataCollection?locationCode=${state.shoppingPreference.outletCode}&shippingDetailsId=${shippingDetailsId}`).then(response => {
        if (response.data.statusCode === 200) {
            store.dispatch(addWebDataCollection(response.data.result)).then(() => {
            })
        }
        else {
            let messageBox = {
                show: true,
                title: "Oops!",
                className: "error",
                content: response.data.errorList[0].statusMessage,
                isConfirmation: false,
                callBackFunction: null
            }
            store.dispatch(showMessageBox(messageBox));
        }
        store.dispatch(hideLoadingScreen());
        callback?.();
    })
}

export function getSuggestedItemsInitially() {
    return new Promise((resolve, reject) => {
        store.dispatch(showLoadingScreen());
        const state = store.getState();
        return get(`/Web/GetSuggestedItems?locationCode=${state.shoppingPreference.outletCode}`)
            .then(response => {
                if (response.data.statusCode === 200) {
                    store.dispatch(addSuggestedItems(response.data.result))
                        .then(() => {
                            resolve(response.data.result)
                            return;
                        })
                }
                else {
                    let messageBox = {
                        show: true,
                        title: "Oops!",
                        className: "error",
                        content: response.data.errorList[0].statusMessage,
                        isConfirmation: false,
                        callBackFunction: null
                    }
                    store.dispatch(showMessageBox(messageBox));
                    resolve()
                }
            }).catch((error)=>reject(error))
            .finally(() => {
                store.dispatch(hideLoadingScreen());
            });
    })

}

export function addUserRedirect(url, redirect) {

    let path = url.split('/')[1];
    if (path === "showcase") {
        url = url.replace("showcase", "showcaseint")
    }
    if (path === "onlinestore") {
        url = url.replace("onlinestore", "onlinestoreint")
    }
    if (path.includes("productDetail")) {
        url = url.replace("productDetail", "productDetailint")
    }
    if (path.includes("donation")) {
        url = url.replace("donation", "donationPayment")
    }
    let data = {
        redirectUrl: url
    }
    store.dispatch(updateUserRedirect(data)).then(() => {
        window.location.href = redirect;
    });
}

export function UserLoginPrompt() {
    let messageBox = {
        show: true,
        title: "User Login",
        className: "warning",
        content: "You are not logged in.\nPlease login to continue shopping!\nDo you want to login?",
        isConfirmation: true,
        callBackFunction: (result) => {
            if (result) {
                if (window.location.pathname === '/productDetail') {
                    addUserRedirect(window.location.pathname + window.location.search, "/welcome/Login");
                } else {
                    addUserRedirect(window.location.pathname, "/welcome/Login");
                }

            }
        }
    }
    store.dispatch(showMessageBox(messageBox));
};

export function getSystemDateTime() {
    let d = new Date();

    // convert to msec
    // add local time zone offset
    // get UTC time in msec
    let utc = d.getTime() + (d.getTimezoneOffset() * 60000);

    // create new Date object for different city
    // using supplied offset
    return new Date(utc + (3600000 * +5.5));
}

export function isValidMobileNumber(mobileNumber) {
    const phoneRegex = RegExp('^0[7][0-9]{8}$');
    if (mobileNumber.length != 10 || !phoneRegex.test(mobileNumber.toString())) {
        return false;
    } else {
        return true;
    }
}

export function genarateProductSearchURL(searchQuery) {
    return `/product?cat=${productListingTypeEnum.listByProductName}&s=${encodeURIComponent('~' + searchQuery)}`;
}

export function decodeUrl(url) {
    return decodeURIComponent(url);
}

export function local_logException(error) {
    const state = store.getState();

    decrypt(state.userDetails.customerID).then((decryptedID)=>{
        let customerID = decryptedID;
    let clientLogDate = new Date().toLocaleString();
    localStorage.setItem(LocalStorageEnum.ErrorCustomerID, customerID);
    localStorage.setItem(LocalStorageEnum.ErrorObject, error);
    localStorage.setItem(LocalStorageEnum.ErrorTimeStamp, clientLogDate);
    });
}

export function onlinestorelogin() {
    UserLoginPrompt();
}

export function getPaymentTokenRequestData(orderNumber, payableAmount, currencyType, currencyRate, merchantID) {
    let postBody = { OrderNumber: orderNumber, Amount: payableAmount, Currency: currencyType, Rate: currencyRate, SelectBankPromoMerchantID: merchantID }

    store.dispatch(showLoadingScreen());
    post("/CardPayments/BuildPaymentTokenRequest", postBody).then(response => {
        if (response.status === 200) {
            if (response.data.errorList[0]["errorType"] == 4) {
                SetupCardPayment(response.data.result, PaymentMethods.VisaMaster, 0, 0, false, null);
            }
            else {
                store.dispatch(hideLoadingScreen());
                let messageBox = {
                    show: true,
                    title: "ERROR",
                    className: "error",
                    content: response.data.errorList[0]["statusMessage"],
                    isConfirmation: false,
                    callBackFunction: () => { }
                }
                store.dispatch(showMessageBox(messageBox));
            }
        }
    })
}

export function markAsRead(notificationID) {
    if (notificationID) {
        store.dispatch(showLoadingScreen());
        // this.props.showLoadingScreen();
        post("/Notification/MarkAsRead?notificationID=" + notificationID).then(response => {
            if (response.data.statusCode == 200) {
                store.dispatch(updateIsNexusFlag(false));
            } else {
                let errorType = response.data.errorList[0].errorType;
                let messageBox = {
                    show: true,
                    title: errorTypesEnum.error === errorType ? "Oops!" : errorTypesEnum.warning === errorType ? "Warning" : "Information",
                    className: errorTypesEnum.error === errorType ? "error" : errorTypesEnum.warning === errorType ? "warning" : "info",
                    content: response.data.errorList[0].statusMessage,
                    isConfirmation: false,
                    callBackFunction: null
                }
                // this.props.showMessageBox(messageBox);
                store.dispatch(showMessageBox(messageBox));
            }
            // this.props.hideLoadingScreen();
            store.dispatch(hideLoadingScreen());
        })
    }
}

export function UpdateUserIPData() {
    store.dispatch(showLoadingScreen());
    post("/MyAccount/UpdateUserIPData").then(response => {
        if (response.data.statusCode == 200) {
        }

        store.dispatch(hideLoadingScreen());
    })
}

export function updateOutlet(callback) {
    store.dispatch(showLoadingScreen());
    const state = store.getState();
    const outletCode = state.shoppingPreference.shoppingMethod == shoppingMethod.delivery ? state.userDetails.selectedOutlet : state.shoppingPreference.outletCode;
    var cartItemList = [];

    decrypt(state.userDetails.customerID).then((decryptedID)=>{
            cartItemList = state.itemCart.map(e => {
        return {
            ItemCode: e.itemCode == undefined ? "" : (e.itemCode).toString(),
            ItemID: e.itemID == undefined ? "" : (e.itemID).toString(),
            CustomerID: decryptedID == undefined ? "" : (decryptedID).toString(),
            Quantity: e.quantity == undefined ? "0" : (e.quantity).toString(),
        };
    });

    let availableCartDetails = {
        OutletCode: outletCode,
        CartItems: cartItemList,
    }

    //get(`/Web/GetTemporarySavedCart?outletCode=${outletCode}`).then(response => {
    if ((state.itemCart).length > 0) {
        post("/Web/GetUpdateOutletItemsCart", availableCartDetails).then(response => {
            if (response.data.statusCode === 200) {
                if (response.data.result.itemDetailsList !== null) {
                    store.dispatch(addPromotionItems(response.data.result.promotionItemDetailsList)).then(() => {
                        AddRecoveryCartItemToCart(response.data.result.itemDetailsList, true, () => {
                            store.dispatch(updateIsTemporaryCart(false));
                            store.dispatch(hideLoadingScreen());
                            callback();
                        });
                        const UpdatedCount = response.data.result.itemDetailsList.filter(item => (item.isUpdateQuantity === true));
                        if (UpdatedCount.length > 0) {
                            let messageBox = {
                                show: true,
                                title: "Oops!",
                                className: "warning",
                                content: response.data.errorList[0].statusMessage,
                                isConfirmation: false,
                                callBackFunction: null
                            }
                            store.dispatch(hideLoadingScreen());
                            store.dispatch(showMessageBox(messageBox));
                        }
                    })
                }
                else {
                    store.dispatch(hideLoadingScreen());
                    callback();
                }
            } else {
                let messageBox = {
                    show: true,
                    title: "Oops!",
                    className: "error",
                    content: response.data.errorList[0].statusMessage,
                    isConfirmation: false,
                    callBackFunction: null
                }
                store.dispatch(hideLoadingScreen());
                store.dispatch(showMessageBox(messageBox));
            }
        })
    }
    else {
        store.dispatch(hideLoadingScreen());
        store.dispatch(resetPreferenceModal());
        setTimeout(function () {
            window.location.href = "/cart";
        }, 900);
    }
    });

}

export const BlockSpan = {
    display: "block"
};

export const NoneSpan = {
    display: "none"
};
